export default __webpack_public_path__ + "static/1637-a09382454290498a5a8642810beecbc0.gif";